import AbsolutePane from './_absolute-pane.js'

export default {
  name: 'ToastOverlay',
  values: {
    items: [
      {
        type: 'simpleToast',
      },
      {
        type: 'selectionsLimitBreachToast',
      },
    ],
    container: {
      configSet: AbsolutePane,
      configValues: {
        fixed: true,
        style: {
          left: 'env(safe-area-inset-left, 0px)',
          right: 'env(safe-area-inset-right, 0px)',
          top: 'env(safe-area-inset-top, 0px)',
          zIndex: 1000,
          alignItems: 'center',
          flexDirection: 'column',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
